
export default {
    fontSize: 20,
    color: 'rgb(24, 144, 255)'
}


// WEBPACK FOOTER //
// ./src/components/icon.cs.js